<template>
  <ul class="nav-list header-nav">
    <li class="nav-item">
      <span class="login-user">{{ this.userAD }}</span>
    </li>
    <li class="langBtn">
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="el-dropdown-link">
          {{ language.name }}
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(option, i) in localeOption"
            :key="i"
            :value="option.locale"
            :command="option.locale"
          >
            {{ option.name }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </li>
    <li class="btn logoutBtn">
      <a v-on:click="logout">{{ $t("system.Logout") }}</a
      ><!--Logout-->
    </li>
  </ul>
</template>

<script>
import { store } from "@/store/store.js"
import { setCookie, delCookie } from "@/utils/cookie"
import { mapActions } from "vuex"

export default {
  name: "HeaderNav",
  components: {},
  data() {
    return {
      localeOption: [
        //{ locale: 'en', name: 'English' },
        { locale: "zh-tw", name: "繁體中文" },
        { locale: "zh-cn", name: "简体中文" },
        { locale: "en", name: "English" },
      ],
      userAD: "",
    }
  },
  mounted() {
    if (store.state.UserLoginData.userAD) {
      this.userAD = store.state.UserLoginData.userAD
    }
  },
  methods: {
    ...mapActions(["setLogin"]),
    handleCommand(command) {
      this.$i18n.locale = command
      sessionStorage.setItem("Accept-Language", command)
      store.dispatch("setLanguage", command)
    },
    logout() {
      delCookie(process.env.VUE_APP_AUTH_TOKEN_NAME)
      this.setLogin(false)
      this.$router.push({ path: "/Login" })
    },
  },
  computed: {
    updateUserAD() {
      return store.state.UserLoginData.userAD
    },
    language() {
      return this.localeOption.find((x) => x.locale == this.$i18n.locale)
    },
  },
  watch: {
    updateUserAD(newValue, oldValue) {
      this.userAD = newValue
    },
  },
}
</script>

<style scoped>
.el-select >>> .el-input {
  width: 120px;
}
.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.nav-item {
  margin: 0 10px;
}
.nav-item a {
  text-decoration: none;
  color: #fefefe;
}
.nav-item a:hover,
.nav-item a:active {
  color: #b4b4b4;
}
.login-user {
  position: relative;
  margin-left: 20px;
  margin-right: 15px;
  color: #ffffff;
  font-size: 18px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #ffffff;
  padding: 17px 18px 16px 18px;
  font-size: 14px;
  font-family: "Segoe UI", "Microsoft JhengHei", "Microsoft YaHei", "Arial";
  margin-left: 10px;
}
.el-dropdown-link:focus,
.el-dropdown-link:hover {
  color: #ffffff;
  background-color: #0089c8;
}
.el-icon-arrow-down {
  font-size: 14px;
}
.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
.header-nav.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.header-nav.nav-list li.btn {
  font-size: 14px;
  color: #ffffff;
  padding: 13px 20px;
  position: relative;
  -webkit-border-radius: 0px;
  -moz-border-radius: 0px;
  border-radius: 0px;
}
.header-nav.nav-list li.btn:hover {
  cursor: pointer;
  color: #ffffff;
  background-color: #0089c8;
}
@media (min-width: 1026px) {
  .nav-list li {
    float: left;
  }
}
@media (max-width: 1025px) {
  .header-nav.nav-list li.langBtn {
    position: absolute;
    top: 29px;
    left: 120px;
  }
  .header-nav.nav-list li.logoutBtn {
    position: absolute;
    top: 15px;
    left: 30px;
  }
  .langBtn .el-dropdown-link {
    padding: 15px 20px;
  }
  .header-nav.nav-list li.btn {
    background-color: #0089c8;
  }
  .nav-list {
    /*display: flex;*/
    display: block;
    /*flex-basis: auto;*/
  }
  .nav-item {
    margin-top: 40px;
    margin-bottom: 16px;
  }
  .login-user {
    margin-left: 0px;
    color: #fff;
    font-size: 18px;
  }
  .el-dropdown-link {
    padding: 10px 9px 10px 9px;
  }
  #admin-select {
    width: 100px;
  }
}
/*@media (min-width: 768px) {
  .nav-list {
    display: flex;
  }
}
#admin-select {
  width: 100px;
}*/
</style>
